import { asyncLoad } from '@util'
import SingleProduct from '@components/LocalMerchant/SingleProduct'
import Introduce from '@components/LocalMerchant/SingleProduct/Introduce'
import Publish from '@components/LocalMerchant/SingleProduct/Publish'
import RelatedCases from '@components/LocalMerchant/SingleProduct/RelatedCases'
import SetMealCreate from '@components/LocalMerchant/SetMealCreate'

const AsyncSingleProduct = asyncLoad(() =>
  import('@components/LocalMerchant/SingleProduct/Home')
)

export default {
  path: 'singleProduct',
  component: SingleProduct,
  indexRoute: {
    component: AsyncSingleProduct
  },
  stat: '单品管理/首页',
  moduleName: '单品管理',
  childRoutes: [
    {
      path: 'introduce',
      component: Introduce,
      stat: '单品管理/相关案例'
    },
    {
      path: 'relatedCases(/:id)',
      component: RelatedCases,
      stat: '单品管理/相关案例'
    },
    {
      path: 'publish',
      component: Publish,
      stat: '单品管理/选择单品类型'
    },
    {
      path: 'create(/:id)',
      component: SetMealCreate,
      stat: '单品管理/发布单品'
    },
    {
      path: 'draftBox',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/SingleProduct/DraftBox')
      ),
      stat: '单品管理/草稿箱',
      title: '草稿箱'
    },
    {
      path: 'review',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/SingleProduct/Review')
      ),
      stat: '单品管理/单品审核记录',
      title: '单品审核记录'
    }
  ]
}
